import styled from 'styled-components';

export const MobileBigIcon = styled.img`
  width: clamp(36px, 5.5vw, 44px);
  height: auto;
`;

export const MobileMediumIcon = styled.img`
  width: clamp(28px, 4.5vw, 34px);
  height: auto;
`;

export const MobileStandardIcon = styled.img`
  width: clamp(14px, 3vw, 30px);
  height: auto;
`;
export const MobileSmallIcon = styled.img`
  width: clamp(15px, 2vw, 20px);
  height: auto;
`;

export const BigIcon = styled.img`
  width: clamp(20px, 4vw, 40px);
  height: auto;
`;

export const MediumIcon = styled.img`
  width: clamp(20px, 3vw, 30px);
  height: auto;
`;

export const StandardIcon = styled.img`
  width: clamp(10px, 2vw, 20px);
  height: auto;
`;

export const SmallIcon = styled.img`
  width: clamp(10px, 1.2vw, 18px);
  height: auto;
`;
